import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { notFound } from '../../assets';
import leng from '../../constants/leng';
import LogoController from '@/layout/login/components/LogoController/LogoController';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';
import { selectSelectedLanguage } from '../../pages/store/language/selectors';

const LoaderInvoice = () => {
  const selectedLanguage = useSelector(selectSelectedLanguage);
  const { whiteLabelState } = useWhiteLabelService();

  return (
    <Box className="max-w-[650px] mx-auto">
      <Box className="mb-5">
        <LogoController
          isWhiteLabel={!!whiteLabelState?.organizationID}
          efexLogoProps={{ className: 'max-w-[150px] ml-4 mt-2' }}
          whiteLabelLogo={whiteLabelState.organizationLogoURL}
        />
      </Box>
      <Box className="max-w-[600px] mx-auto mt-5 text-center pt-5">
        <img
          className="max-w-[200px] mb-5 mx-auto"
          src={notFound}
          width="100"
          alt="under_review"
        />
        <Typography variant="h6">
          {leng[selectedLanguage.language].invoiceLoadingHeader}
        </Typography>
        <Typography variant="body1" className="!my-5">
          {leng[selectedLanguage.language].invoiceLoadingBody}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoaderInvoice;
